import { render, staticRenderFns } from "./adiarAulaDialog.vue?vue&type=template&id=31dbaa91&scoped=true"
import script from "./adiarAulaDialog.vue?vue&type=script&lang=js"
export * from "./adiarAulaDialog.vue?vue&type=script&lang=js"
import style0 from "./adiarAulaDialog.vue?vue&type=style&index=0&id=31dbaa91&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31dbaa91",
  null
  
)

export default component.exports